<template>
    <!-- {{ props.context.isFull }} -->
    <!-- {{ props.context.allowredFileTypes }} -->
    <template v-if="props.context.isProfile">
        <!-- {{ props.context.isProfile }}
        {{ props.context.id }} -->
        <div style="width: 180px" class="filepond-uploader-width">
            <input
                :id="'profile-' + (props.id ? props.id : props.context.id)"
                :name="fileName"
                type="file"
                class="profileUpload w-22.5"
                @change="handleInputFile"
            />
        </div>
    </template>
    <template v-else-if="props.context.isSingle">
        <!-- {{ props.context.filesData }}
        {{ filesData }} -->

        <div
            :class="[
                isFull || props.context.isFull
                    ? 'w-full'
                    : 'xs:!w-full md:!w-[360px] sm:!w-full',
            ]"
        >
            <input
                type="file"
                class="defaultImageUpload w-22.5"
                @change="handleInputFile"
                :id="'filepond-' + (props.id ? props.id : props.context.id)"
                :name="fileName"
            />
        </div>
    </template>
    <template v-else>
        <div
            :class="[
                isFull || props.context.isFull
                    ? 'w-full'
                    : 'xs:!w-full md:!w-[360px] sm:!w-full',
            ]"
        >
            <input
                type="file"
                class="defaultImageUpload w-22.5"
                @change="handleInputFile"
                multiple
                :id="'filepond-' + (props.id ? props.id : props.context.id)"
                :name="fileName"
            />
        </div>
    </template>
</template>

<script setup>
import { onMounted, ref, nextTick, watch, computed } from 'vue';
import { getNode } from '@formkit/core';
import {
    openEditor,
    processImage,
    createDefaultImageReader,
    createDefaultImageWriter,
    getEditorDefaults,
    blobToFile,
} from '@/assets/filepond/pintura/pintura.js';
import heic2any from 'heic2any';
import FilePondPluginImageEditor from '@/assets/filepond/filepond-plugin-image-editor/FilePondPluginImageEditor.js';
import FilePondPluginGetFile from 'filepond-plugin-get-file';
// import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

const emit = defineEmits(['userImage', 'addedFile']);

const props = defineProps({
    context: Object,
    isProfile: {
        type: Boolean,
        default: false,
    },
    modelValue: {
        type: [String, Number],
        default: '',
    },
    isSingle: {
        type: Boolean,
        default: false,
    },
    serverUrl: {
        type: String,
        default: '',
    },
    fileName: {
        type: [String, Number],
        default: '',
    },
    id: {
        type: [String, Number],
        default: '',
    },
    fileSource: {
        type: Array,
        default: () => [],
    },
    filesData: {
        type: Array,
        default: () => [],
    },
    fileType: {
        type: String,
        default: '',
    },
    uuid: {
        type: String,
        default: '',
    },
    folderName: {
        type: String,
        default: '',
    },
    fromFile: {
        type: String,
        default: '',
    },
    isFull: {
        type: Boolean,
    },
});

const profileImage = ref('');
const appImages = ref(null);
const uploadPond = ref(null);
const pond = ref();
let imagesToShow = ref([]);
const filesData = computed(() => props.context.filesData || []);

const myArray = ref([]);
const urlToFile = async (url, name, mimeType) => {
    if (!url) {
        throw new Error('URL is undefined');
    }
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], name, { type: mimeType });
};

const handleInputFile = async (input) => {
    // myArray.value = []
    let files;

    if (input.target && input.target.files) {
        // Traditional input event
        files = input.target.files;
    } else if (input.file) {
        // FilePond fileItem
        files = [input.file];
    } else {
        console.error('Invalid input source for handleInputFile');
        return;
    }

    const updatedFiles = [];

    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        // Check if the file is from a URL or a local upload
        if (file.url) {
            // Handle Blob from URL
            try {
                const fileObject = await urlToFile(
                    file.url,
                    file.name,
                    file.type
                );
                updatedFiles.push(fileObject);
            } catch (error) {
                console.error('Error converting URL to file:', error);
            }
        } else {
            // Handle regular file input
            updatedFiles.push(file);
        }
    }

    // myArray.value = [...myArray.value, ...updatedFiles];
    // Filter out duplicates
    updatedFiles.forEach((newFile) => {
        const existingFile = myArray.value.find(
            (file) => file.name === newFile.name && file.size === newFile.size
        );
        if (!existingFile) {
            myArray.value.push(newFile);
        }
    });
    getNode(props.context.id).input(myArray.value);
};

const handleFileRemoval = (file) => {
    const index = myArray.value.findIndex(
        (item) => item.name === file.file.name
    );
    if (index > -1) {
        myArray.value.splice(index, 1);
    }
    getNode(props.context.id).input(myArray.value);
};

const initFilepond = async () => {
    FilePond.registerPlugin(
        FilePondPluginFileValidateType,
        FilePondPluginImageEditor,
        FilePondPluginFilePoster,
        FilePondPluginGetFile
    );

    const input = document.querySelector(
        '#filepond-' + (props.id ? props.id : props.context.id)
    );

    uploadPond.value = FilePond.create(input, {
        allowReorder: true,
        filePosterMaxHeight: 256,
        storeAsFile: true,
        allowDownloadByUrl: false,
        labelButtonDownloadItem: 'custom label',
        // acceptedFileTypes: [
        //     'image/*',
        //     'application/pdf',
        //     'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        //     'application/msword',
        //     'text/csv',
        //     'application/vnd.ms-excel',
        //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        // ],
        acceptedFileTypes: props.context.allowedFileTypes ?? [
            'image/*',
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword',
            'text/csv',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ],
        labelFileTypeNotAllowed: generateLabelFileTypeNotAllowed(acceptedTypes),
        fileValidateTypeLabelExpectedTypes:
            'Expects {allButLastType} or {lastType}',
        fileValidateTypeDetectType: (source, type) =>
            new Promise((resolve, reject) => {
                // Do custom type detection here and return with promise
                resolve(type);
            }),
        maxFileSize: '10MB', // Limit the maximum file size
        allowMultiple: props.context.isSingle ? false : true, // Allow multiple file uploads
        onaddfile: (error, fileItem) => {
            const allowedFileTypes = props.context.allowedFileTypes ?? [
                'image/*',
            ];
            if (!error && allowedFileTypes.includes(fileItem.file.type)) {
                handleInputFile(fileItem);
            }
        },
        imageEditorAfterWriteImage: async (res) => {
            let fileObject;
            try {
                // Check the value of props.context.fileFrom
                let fileUrl;
                if (!props.context.fromFile) {
                    fileUrl = res.dest;
                } else if (props.context.fromFile === 'contact') {
                    fileUrl = res.src;
                } else {
                    throw new Error('Invalid fileFrom value');
                }

                if (fileUrl && typeof fileUrl === 'string') {
                    fileObject = await urlToFile(fileUrl, res.name, res.type);
                } else {
                    fileObject = res.src;
                }
                handleInputFile({ target: { files: [fileObject] } });
            } catch (error) {
                console.error('Error in imageEditorAfterWriteImage:', error);
            }
            return res;
        },
        onremovefile: (error, file) => {
            handleFileRemoval(file);
        },
        onactivatefile: (e, o) => {
            // Custom logic when file is activated
        },
        imageEditor: {
            createEditor: openEditor,
            imageReader: [
                createDefaultImageReader,
                {
                    // Converting the HEIC file to a JPEG
                    preprocessImageFile: async (file, options, onprogress) => {
                        // If is HEIC, we preprocess to a readable image format
                        if (/heic/.test(file.type)) {
                            // let's turn HEIC into JPEG so the browser can read it
                            const blob = await heic2any({
                                blob: file,
                                toType: 'image/jpeg',
                                quality: 0.94,
                            });

                            // Pintura Image Editor expects a File
                            return blobToFile(blob, file.name);
                        }

                        // no need to preproces
                        return file;
                    },
                },
            ],
            imageWriter: [
                createDefaultImageWriter,
                {
                    quality: 1, // Set quality to 1 to avoid compression
                },
            ],
            imageProcessor: processImage,
            editorOptions: {
                // ...[props.context.fromFile == undefined ? getEditorDefaults() : ''],
                ...getEditorOptions(),
                imageCropAspectRatio: undefined,
            },
        },
    });
};

const getEditorOptions = () => {
    const defaults = getEditorDefaults();
    if (props.context.fromFile !== 'contact') {
        // Adjust defaults or return a different object based on your requirements
        return { ...defaults, additionalOption: 'value' };
    }
    return;
};

const getImages = async () => {
    imagesToShow.value = [];
    if (filesData.value) {
        for (let file of filesData.value) {
            const fileObject = await urlToFile(
                file.url,
                file.name,
                `image/${file.ext}`
            );
            imagesToShow.value.push(fileObject);
        }
        nextTick(() => {
            uploadPond.value.addFiles(imagesToShow.value);
        });
    }
};

const removeImages = () => {
    if (uploadPond.value) {
        const files = uploadPond.value.getFiles();
        files.forEach((file) => {
            uploadPond.value.removeFiles(file.id);
        });
    }
};

watch(
    () => props.context.filesData,
    (newVal, oldVal) => {
        if (!props.context.filesData) return;
        // let propsId = props.context.id.split('-')[2];
        // console.log(propsId, 'filesource filepond propsId')
        // let img = props.context.filesData?.filter((img) => img.field_name == propsId).map((item) => ({ ...item }));
        // imagesToShow.value = img;
        // console.log(imagesToShow.value, 'filesource filepond imagesToShow.value')
        if (newVal && newVal.length) {
            getImages();
        } else {
            removeImages();
        }
    },
    {
        deep: true,
        immediate: true, // [info]: this also need to run on initial load for pre-filled images
    }
);
const fileTypeLabels = {
    'image/*': 'Images',
    'application/pdf': 'PDFs',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        'DOCX files',
    'application/msword': 'DOC files',
    'text/csv': 'CSV files',
    'application/vnd.ms-excel': 'Excel files',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        'Excel files',
};
const generateLabelFileTypeNotAllowed = (acceptedTypes) => {
    const readableTypes = acceptedTypes.map(
        (type) => fileTypeLabels[type] || type
    );
    return `Invalid file type. Only ${readableTypes.join(', ')} are allowed.`;
};
const acceptedTypes = props.context.allowedFileTypes ?? [
    'image/*',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'text/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
onMounted(async () => {
    await initFilepond();
    nextTick(() => {
        getImages();
    });
});
</script>

<style scoped>
:deep(.filepond--file-status) {
    flex-direction: row;
    margin-left: 0;
    display: block !important;
}
:deep(.filepond--file-status-sub) {
    display: none !important;
}
:deep(.filepond--file-status-main) {
    display: flex;
    white-space: pre-wrap;
    text-align: left;
}
:deep(.filepond--file-status) {
    flex-shrink: inherit;
}
</style>
